<template>
  <div class="modern-form">
    <div class="form-container">
      <div class="section-header">
        <h2 class="section-title">Account Information</h2>
      </div>
      <v-form
        ref="form"
        @submit.prevent="submitForm"
        v-model="isFormValid"
        lazy-validation
        class="">
      
      <div class="form-row">
        <div class="form-group">
          <v-text-field
            v-model="form.firstName"
            label="First Name"
            :rules="[rules.required, rules.name]"
            class="line-input custom-filled"
            dense
            hide-details="auto"
            required
            type="text" />
        </div>
        <div class="form-group">
          <v-text-field
            v-model="form.lastName"
            label="Last Name"
            :rules="[rules.required, rules.name]"
            class="line-input custom-filled"
            dense
            hide-details="auto"
            required
            type="text" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <v-text-field
            v-model="form.email"
            label="Email"
            :rules="[rules.required, rules.email]"
            class="line-input custom-filled"
            dense
            hide-details="auto"
            required
            type="email" />
        </div>
        <div class="form-group">
          <v-text-field
            v-model="form.phone"
            label="Phone Number"
            :rules="[rules.phone]"
            class="line-input custom-filled"
            dense
            hide-details="auto"
            type="phone" />
        </div>
      </div>

      <div class="form-actions">
        <v-btn
          class="btn-primary"
          @click="submitForm"
          :disabled="!isFormValid"
          :loading="isSubmitting">
          Save
        </v-btn>
      </div>
    </v-form>
    </div>
  </div>
</template>
<script>
import DataService from '../../../_services/DataService';
import ValidateService from '../../../_services/ValidateService';

export default {
  data() {
    return {
      isFormValid: false,
      isSubmitting: false,
      form: {
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
      },
      rules: ValidateService.validators,
    };
  },
  computed: {
    passwordConfirmationRule() {
      return () => (this.form.new_password === this.form.repeat_password) || 'Passwords must match';
    },
  },
  methods: {
    async submitForm() {
      try {
        if (this.$refs.form.validate()) {
          this.isSubmitting = true;
          const response = await DataService.updateAccountInfo(this.form);
          if (response.status === 200) {
            localStorage.setItem('user', JSON.stringify(this.form));
            this.$root.$emit('raise_alert', { color: 'success', text: 'Account information updated successfully' });
          } else {
            this.$root.$emit('raise_alert', { color: 'error', text: response.data || 'Something went wrong.' });
          }
        }
      } catch (err) {
        this.$root.$emit('raise_alert', { color: 'error', text: 'Something went wrong.' });
      } finally {
        this.isSubmitting = false;
      }
    },
  },
  mounted() {
    this.form = JSON.parse(localStorage.getItem('user'));
  },
};
</script>
<style lang="scss" scoped>
.modern-form:first-child {
  margin-bottom: 16px;
}
</style>
